import { render } from "./RegistrationApprovalView.vue?vue&type=template&id=8ebb4894"
import script from "./RegistrationApprovalView.vue?vue&type=script&lang=js"
export * from "./RegistrationApprovalView.vue?vue&type=script&lang=js"

import "./RegistrationApprovalView.vue?vue&type=style&index=0&id=8ebb4894&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__